<div class="container-fluid mt-2">
  <div class="p-4 rounded">
    <div class="row justify-content-center">
      <h5 class="text-secondary">Editar solicitud de evaluación para capacidad de pago - Persona natural</h5>
      <!-- Separador -->
      <hr width="90%">
    </div>
    <form [formGroup]="forma" (ngSubmit)="editar()">
      <div class="row justify-content-end">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group text-left" [ngClass]="{ 'text-danger': startDate.invalid && startDate.touched }">
            <label class="col-form-label col-form-label-sm">Día / Mes / Año</label>
            <div class="input-group">
              <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle()" placeholder="Día/Mes/Año" [minDate]="hoy" [maxDate]="hoy" readonly formControlName="startDate">
              <button class="btn btn-info btn-sm" (click)="d1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
            </div>
            <div *ngIf="startDate.errors && (startDate.dirty || startDate.touched)">
              <span *ngIf="startDate.errors.required">Requerido</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': transfer.invalid && transfer.touched }">
            <label class="col-form-label col-form-label-sm">Cesión</label>
            <ng-select
              class="custom"
              readonly="true"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="transfer">
              <ng-option value="Si">Si</ng-option>
              <ng-option value="No">No</ng-option>
            </ng-select>
            <div *ngIf="transfer.errors && (transfer.dirty || transfer.touched)">
              <span *ngIf="transfer.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': role.invalid && role.touched }">
            <label class="col-form-label col-form-label-sm">Rol</label>
            <ng-select
              [items]="tr"
              bindValue="valueId"
              bindLabel="name"
              class="custom"
              [virtualScroll]="true"
              [readonly]="preLoad"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="role">
            </ng-select>
            <div *ngIf="role.errors && (role.dirty || role.touched)">
              <span *ngIf="role.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': debtor.invalid && debtor.touched }">
            <label class="col-form-label col-form-label-sm">Deudor</label>
            <ng-select
              [items]="tp"
              bindValue="valueId"
              bindLabel="name"
              class="custom"
              [virtualScroll]="true"
              [readonly]="preLoad"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="debtor">
            </ng-select>
            <div *ngIf="debtor.errors && (debtor.dirty || debtor.touched)">
              <span *ngIf="debtor.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group" [ngClass]="{ 'text-danger': contractNumber.invalid && contractNumber.touched }">
            <label class="col-form-label col-form-label-sm">Contrato</label>
            <input type="text" class="form-control form-control-sm" [readonly]="adjudgedInfo?.quotaNumber" formControlName="contractNumber">
            <div *ngIf="contractNumber.errors && (contractNumber.dirty || contractNumber.touched)">
              <span *ngIf="contractNumber.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group" [ngClass]="{ 'text-danger': quotaNumber.invalid && quotaNumber.touched }">
            <label class="col-form-label col-form-label-sm">Cupo (Grupo, Afiliación nivel)</label>
            <input type="text" class="form-control form-control-sm" [readonly]="adjudgedInfo?.contractNumber" formControlName="quotaNumber">
            <div *ngIf="quotaNumber.errors && (quotaNumber.dirty || quotaNumber.touched)">
              <span *ngIf="quotaNumber.errors.required">Requerido</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="accordion" role="tablist">
        <div class="card"> -->
          <div class="card-header" role="tab" id="tituloSolicitante" data-toggle="collapse" data-target="#infoSolicitante" aria-expanded="false" aria-controls="infoSolicitante">
            <h6 class="mb-0">Información del solicitante</h6>
          </div>
          <div id="infoSolicitante" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloSolicitante">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': name.invalid && name.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre completo</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.name" formControlName="name">
                  <div *ngIf="name.errors && (name.dirty || name.touched)">
                    <span *ngIf="name.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': lastName.invalid && lastName.touched }">
                  <label class="col-form-label col-form-label-sm">Primer apellido</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.lastName" formControlName="lastName">
                  <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched)">
                    <span *ngIf="lastName.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': surname.invalid && surname.touched }">
                  <label class="col-form-label col-form-label-sm">Segundo apellido</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.surname" formControlName="surname">
                  <div *ngIf="surname.errors && (surname.dirty || surname.touched)">
                    <span *ngIf="surname.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': documentNumber.invalid && documentNumber.touched }">
                  <label class="col-form-label col-form-label-sm">No. identificación</label>
                  <div class="input-group">
                    <ng-select
                      [items]="td"
                      bindValue="valueId"
                      bindLabel="valueId"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      [readonly]="adjudged?.typeOfIdentity"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="typeOfIdentity">
                    </ng-select>
                    <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.documentNumber" formControlName="documentNumber">
                  </div>
                  <div *ngIf="documentNumber.errors && (documentNumber.dirty || documentNumber.touched)">
                    <span *ngIf="documentNumber.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionDate.invalid && expeditionDate.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de expedición</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()" placeholder="Día/Mes/Año" [maxDate]="hoy" readonly formControlName="expeditionDate">
                    <button class="btn btn-info btn-sm" (click)="d2.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                  </div>
                  <div *ngIf="expeditionDate.errors && (expeditionDate.dirty || expeditionDate.touched)">
                    <span *ngIf="expeditionDate.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionDepartment.invalid && expeditionDepartment.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento de expedición</label>
                  <ng-select
                    (change)="c10 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="expeditionDepartment">
                  </ng-select>
                  <div *ngIf="expeditionDepartment.errors && (expeditionDepartment.dirty || expeditionDepartment.touched)">
                    <span *ngIf="expeditionDepartment.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionCity.invalid && expeditionCity.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad de expedición</label>
                  <ng-select
                    [items]="c10"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!expeditionDepartment.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="expeditionCity">
                  </ng-select>
                  <div *ngIf="expeditionCity.errors && (expeditionCity.dirty || expeditionCity.touched)">
                    <span *ngIf="expeditionCity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- <label class="col-form-label col-form-label-sm d-sm-none d-lg-block">&nbsp;</label> -->
                <div class="form-group" [ngClass]="{ 'text-danger': sex.invalid && sex.touched }">
                  <label class="col-form-label col-form-label-sm">Género</label>
                  <ng-select
                    [items]="s"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sex">
                  </ng-select>
                  <div *ngIf="sex.errors && (sex.dirty || sex.touched)">
                    <span *ngIf="sex.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 3 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- <label class="col-form-label col-form-label-sm d-sm-none d-lg-block">&nbsp;</label> -->
                <div class="form-group" [ngClass]="{ 'text-danger': dateOfBirth.invalid && dateOfBirth.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d3="ngbDatepicker" (click)="!adjudged?.dateOfBirth ? d3.toggle() : ''" placeholder="Día/Mes/Año" [maxDate]="hoy18" readonly formControlName="dateOfBirth">
                    <button class="btn btn-info btn-sm" (click)="!adjudged?.dateOfBirth ? d3.toggle() : ''" type="button"><i class="fa fa-calendar"></i></button>
                  </div>
                  <div *ngIf="dateOfBirth.errors && (dateOfBirth.dirty || dateOfBirth.touched)">
                    <span *ngIf="dateOfBirth.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': nationality.invalid && nationality.touched }">
                  <label class="col-form-label col-form-label-sm">Nacionalidad</label>
                  <ng-select
                    [items]="n"
                    class="custom"
                    bindValue="valueId"
                    bindLabel="name"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="nationality">
                  </ng-select>
                  <div *ngIf="nationality.errors && (nationality.dirty || nationality.touched)">
                    <span *ngIf="nationality.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': civilStatus.invalid && civilStatus.touched }">
                  <label class="col-form-label col-form-label-sm">Estado civil</label>
                  <ng-select
                    [items]="ec"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="civilStatus">
                  </ng-select>
                  <div *ngIf="civilStatus.errors && (civilStatus.dirty || civilStatus.touched)">
                    <span *ngIf="civilStatus.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': academicLevel.invalid && academicLevel.touched }">
                  <label class="col-form-label col-form-label-sm">Nivel académico</label>
                  <ng-select
                    [items]="na"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="academicLevel">
                  </ng-select>
                  <div *ngIf="academicLevel.errors && (academicLevel.dirty || academicLevel.touched)">
                    <span *ngIf="academicLevel.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': profession.invalid && profession.touched }">
                  <label class="col-form-label col-form-label-sm">Profesión</label>
                  <ng-select
                    [items]="p"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [readonly]="academicLevel.value < 4 || academicLevel.value > 6"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="profession">
                  </ng-select>
                  <div *ngIf="profession.errors && (profession.dirty || profession.touched)">
                    <span *ngIf="profession.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group row" [ngClass]="{ 'text-danger': (minorLoad.invalid && minorLoad.touched) || (higherLoad.invalid && higherLoad.touched) }">
                  <label class="col-12 col-form-label col-form-label-sm">Número de personas a cargo</label>
                  <div class="col-6">
                    <ng-select
                      [items]="n15"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="menor de 18"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="minorLoad">
                    </ng-select>
                    <div *ngIf="minorLoad.errors && (minorLoad.dirty || minorLoad.touched)">
                      <span *ngIf="minorLoad.errors.required">Requerido</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <ng-select
                      [items]="n15"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="mayor de 18"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="higherLoad">
                    </ng-select>
                    <div *ngIf="higherLoad.errors && (higherLoad.dirty || higherLoad.touched)">
                      <span *ngIf="higherLoad.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': housing.invalid && housing.touched }">
                  <label class="col-form-label col-form-label-sm">Tipo de vivienda</label>
                  <ng-select
                    [items]="tv"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="housing">
                  </ng-select>
                  <div *ngIf="housing.errors && (housing.dirty || housing.touched)">
                    <span *ngIf="housing.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': rent.invalid && rent.touched }">
                  <label class="col-form-label col-form-label-sm">Declara renta</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="rent">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="rent.errors && (rent.dirty || rent.touched)">
                    <span *ngIf="rent.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 5 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': address.invalid && address.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.address" formControlName="address">
                  <div *ngIf="address.errors && (address.dirty || address.touched)">
                    <span *ngIf="address.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': country.invalid && country.touched }">
                  <label class="col-form-label col-form-label-sm">País</label>
                  <input type="text" class="form-control form-control-sm" readonly formControlName="country">
                  <div *ngIf="country.errors && (country.dirty || country.touched)">
                    <span *ngIf="country.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department.invalid && department.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c1 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="adjudged?.ubication?.departmentId"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department">
                  </ng-select>
                  <div *ngIf="department.errors && (department.dirty || department.touched)">
                    <span *ngIf="department.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city.invalid && city.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l1 = $event ? $event.localities : null"
                    [items]="c1"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department.value || adjudged?.ubication?.cityId"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city">
                  </ng-select>
                  <div *ngIf="city.errors && (city.dirty || city.touched)">
                    <span *ngIf="city.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 6 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location.invalid && location.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l1"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city.value || l1?.length === 0 || adjudged?.ubication?.locationId"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location">
                  </ng-select>
                  <div *ngIf="location.errors && (location.dirty || location.touched)">
                    <span *ngIf="location.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': stratum.invalid && stratum.touched }">
                  <label class="col-form-label col-form-label-sm">Estrato</label>
                  <ng-select
                    [items]="ese"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="stratum">
                  </ng-select>
                  <div *ngIf="stratum.errors && (stratum.dirty || stratum.touched)">
                    <span *ngIf="stratum.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': yearsResidence.invalid && yearsResidence.touched }">
                  <label class="col-form-label col-form-label-sm">Años en la residencia</label>
                  <ng-select
                    [items]="ar"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="yearsResidence">
                  </ng-select>
                  <div *ngIf="yearsResidence.errors && (yearsResidence.dirty || yearsResidence.touched)">
                    <span *ngIf="yearsResidence.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone.invalid && phone.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" [readonly]="adjudged?.phone" formControlName="phone">
                  <div *ngIf="phone.errors && (phone.dirty || phone.touched)">
                    <span *ngIf="phone.errors.required">Requerido</span>
                    <span *ngIf="phone.errors.minlength">Complete los digitos</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 7 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular.invalid && cellular.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" [readonly]="adjudged?.cellPhone" formControlName="cellular">
                  <div *ngIf="cellular.errors && (cellular.dirty || cellular.touched)">
                    <span *ngIf="cellular.errors.required">Requerido</span>
                    <span *ngIf="cellular.errors.minlength">Complete los digitos</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': email.invalid && email.touched }">
                  <label class="col-form-label col-form-label-sm">Email <sup><strong>1</strong></sup></label>
                  <input type="text" class="form-control form-control-sm" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" [readonly]="adjudged?.email" formControlName="email">
                  <div *ngIf="email.errors && (email.dirty || email.touched)">
                    <span *ngIf="email.errors.required">Requerido</span>
                    <span *ngIf="email.errors.pattern || email.errors.email">Formato email incorrecto</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub> Autorizo el envio de mi extracto e información relacionada con el Plan a la dirección eletrónica por mi informada.</sub>
                <div *ngIf="email.value != null && name.value != null && lastName.value != null && surname.value != null && documentNumber.value != null
                  && expeditionDate.value != null && expeditionDepartment.value != null && expeditionCity.value != null && sex.value != null
                  && dateOfBirth.value != null && nationality.value != null && civilStatus.value != null && academicLevel.value != null
                  && minorLoad.value != null && higherLoad.value != null && housing.value != null && rent.value != null && address.value != null
                  && country.value != null && department.value != null && city.value != null && stratum.value != null
                  && yearsResidence.value != null && phone.value != null && cellular.value != null"
                  class=" lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="email.value == null || name.value == null || lastName.value == null || surname.value == null || documentNumber.value == null
                  || expeditionDate.value == null || expeditionDepartment.value == null || expeditionCity.value == null || sex.value == null
                  || dateOfBirth.value == null || nationality.value == null || civilStatus.value == null || academicLevel.value == null
                  || minorLoad.value == null || higherLoad.value == null || housing.value == null || rent.value == null || address.value == null
                  || country.value == null || department.value == null || city.value == null || stratum.value == null
                  || yearsResidence.value == null || phone.value == null || cellular.value == null"
                  class=" lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloConyuge" data-toggle="collapse" data-target="#infoConyuge" aria-expanded="false" aria-controls="infoConyuge" *ngIf="civilStatus.value === 'C' || civilStatus.value === 'U'">
            <h6 class="mb-0">Datos del Conyuge</h6>
          </div>
          <div id="infoConyuge" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloConyuge" *ngIf="civilStatus.value === 'C' || civilStatus.value === 'U'">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': name1.invalid && name1.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre completo</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name1">
                  <div *ngIf="name1.errors && (name1.dirty || name1.touched)">
                    <span *ngIf="name1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': lastName1.invalid && lastName1.touched }">
                  <label class="col-form-label col-form-label-sm">Primer apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="lastName1">
                  <div *ngIf="lastName1.errors && (lastName1.dirty || lastName1.touched)">
                    <span *ngIf="lastName1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': surname1.invalid && surname1.touched }">
                  <label class="col-form-label col-form-label-sm">Segundo apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="surname1">
                  <div *ngIf="surname1.errors && (surname1.dirty || surname1.touched)">
                    <span *ngIf="surname1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': documentNumber1.invalid && documentNumber1.touched }">
                  <label class="col-form-label col-form-label-sm">No. identificación</label>
                  <div class="input-group">
                    <ng-select
                      [items]="td"
                      bindValue="valueId"
                      bindLabel="valueId"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="typeOfIdentity1">
                    </ng-select>
                    <input type="text" class="form-control form-control-sm" formControlName="documentNumber1">
                  </div>
                  <div *ngIf="documentNumber1.errors && (documentNumber1.dirty || documentNumber1.touched)">
                    <span *ngIf="documentNumber1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group text-center" [ngClass]="{ 'text-danger': dateOfBirth1.invalid && dateOfBirth1.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d4="ngbDatepicker" (click)="d4.toggle()" placeholder="Día/Mes/Año" [maxDate]="hoy18" readonly formControlName="dateOfBirth1">
                    <button class="btn btn-info btn-sm" (click)="d4.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                  </div>
                  <div *ngIf="dateOfBirth1.errors && (dateOfBirth1.dirty || dateOfBirth1.touched)">
                    <span *ngIf="dateOfBirth1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': sex1.invalid && sex1.touched }">
                  <label class="col-form-label col-form-label-sm">Género</label>
                  <ng-select
                    [items]="s"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sex1">
                  </ng-select>
                  <div *ngIf="sex1.errors && (sex1.dirty || sex1.touched)">
                    <span *ngIf="sex1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chevyPlan1.invalid && chevyPlan1.touched }">
                  <label class="col-form-label col-form-label-sm info1 mb-1">Tiene relación con ChevyPlan, GM, Concesionario?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chevyPlan1">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chevyPlan1.errors && (chevyPlan1.dirty || chevyPlan1.touched)">
                    <span *ngIf="chevyPlan1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': address1.invalid && address1.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address1">
                  <div *ngIf="address1.errors && (address1.dirty || address1.touched)">
                    <span *ngIf="address1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 3 -->
            <div class="row">
              <!-- <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': country1.invalid && country1.touched }">
                  <label class="col-form-label col-form-label-sm">País</label>
                  <input type="text" class="form-control form-control-sm" readonly formControlName="country1">
                  <div *ngIf="country1.errors && (country1.dirty || country1.touched)">
                    <span *ngIf="country1.errors.required">El país es requerido</span>
                  </div>
                </div>
              </div> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department1.invalid && department1.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c2 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department1">
                  </ng-select>
                  <div *ngIf="department1.errors && (department1.dirty || department1.touched)">
                    <span *ngIf="department1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city1.invalid && city1.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l2 = $event ? $event.localities : null"
                    [items]="c2"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department1.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city1">
                  </ng-select>
                  <div *ngIf="city1.errors && (city1.dirty || city1.touched)">
                    <span *ngIf="city1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location1.invalid && location1.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l2"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city1.value || l2.length === 0"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location1">
                  </ng-select>
                  <div *ngIf="location1.errors && (location1.dirty || location1.touched)">
                    <span *ngIf="location1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone1.invalid && phone1.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone1" minlength="8">
                  <div *ngIf="phone1.errors && (phone1.dirty || phone1.touched)">
                    <span *ngIf="phone1.errors.required">Requerido</span>
                    <span *ngIf="phone1.errors?.minlength">
                      El número de Teléfono debe contener 8 digitos
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular1.invalid && cellular1.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular1" minlength="10">
                  <div *ngIf="cellular1.errors && (cellular1.dirty || cellular1.touched)">
                    <span *ngIf="cellular1.errors.required">Requerido</span>
                    <span *ngIf="cellular1.errors?.minlength">
                      El número de Celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': activities1.invalid && activities1.touched }">
                  <label class="col-form-label col-form-label-sm">Actividad</label>
                  <input type="text" class="form-control form-control-sm" formControlName="activities1" [imask]="nameMask">
                  <!-- <ng-select
                    [items]="act"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="activities1">
                  </ng-select> -->
                  <div *ngIf="activities1.errors && (activities1.dirty || activities1.touched)">
                    <span *ngIf="activities1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <div *ngIf="name1.value != null && lastName1.value != null && documentNumber1.value != null && dateOfBirth1.value != null
                  && sex1.value != null && chevyPlan1.value != null && address1.value != null && department1.value != null
                  && city1.value != null && phone1.value != null && cellular1.value != null && activities1.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="name1.value == null || lastName1.value == null || documentNumber1.value == null || dateOfBirth1.value == null
                || sex1.value == null || chevyPlan1.value == null || address1.value == null || department1.value == null
                || city1.value == null || phone1.value == null || cellular1.value == null || activities1.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloActividad" data-toggle="collapse" data-target="#infoActividad" aria-expanded="false" aria-controls="infoActividad">
            <h6 class="mb-0">Actividad económica principal del solicitante</h6>
          </div>
          <div id="infoActividad" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloActividad">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': ciiu.invalid && ciiu.touched }">
                  <label class="col-form-label col-form-label-sm">Código CIIU</label>
                  <ng-select
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="ciiu">
                    <ng-option *ngFor="let x of ci" [value]="x.valueId">{{x.valueId}} - {{x.name}}</ng-option>
                  </ng-select>
                  <div *ngIf="ciiu.errors && (ciiu.dirty || ciiu.touched)">
                    <span *ngIf="ciiu.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': job.invalid && job.touched }">
                  <label class="col-form-label col-form-label-sm">Actividad</label>
                  <ng-select
                    [items]="emp"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="job">
                  </ng-select>
                  <div *ngIf="job.errors && (job.dirty || job.touched)">
                    <span *ngIf="job.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="job.value === '7'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichJob.invalid && whichJob.touched }">
                  <label class="col-form-label col-form-label-sm">Cual?</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="job.value !== '7'" formControlName="whichJob">
                  <div *ngIf="whichJob.errors && (whichJob.dirty || whichJob.touched)">
                    <span *ngIf="whichJob.errors.required">Indique cual</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3"*ngIf="job.value !== '7'">
                <div class="form-group" [ngClass]="{ 'text-danger': business.invalid && business.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre de la empresa/negocio</label>
                  <input type="text" class="form-control form-control-sm" formControlName="business">
                  <div *ngIf="business.errors && (business.dirty || business.touched)">
                    <span *ngIf="business.errors.required">Requedido</span>
                  </div>
                </div>
              </div>
              <!-- *ngIf="business.value"-->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': antiquity.invalid && antiquity.touched }">
                  <label class="col-form-label col-form-label-sm">Antiguedad</label>
                  <ng-select
                    [items]="ar"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="antiquity">
                  </ng-select>
                  <div *ngIf="antiquity.errors && (antiquity.dirty || antiquity.touched)">
                    <span *ngIf="antiquity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="business.value || job.value === '1' || job.value === '6'">
                <div class="form-group" [ngClass]="{ 'text-danger': position.invalid && position.touched }">
                  <label class="col-form-label col-form-label-sm">Cargo</label>
                  <ng-select
                    [items]="ca"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="position">
                  </ng-select>
                  <div *ngIf="position.errors && (position.dirty || position.touched)">
                    <span *ngIf="position.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="position.value === '32'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichPosition.invalid && whichPosition.touched }">
                  <label class="col-form-label col-form-label-sm">Cual?</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="position.value !== '32'" formControlName="whichPosition">
                  <div *ngIf="whichPosition.errors && (whichPosition.dirty || whichPosition.touched)">
                    <span *ngIf="whichPosition.errors.required">Indique cual</span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 2 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="business.value || job.value === '1' || job.value === '6'">
                <div class="form-group" [ngClass]="{ 'text-danger': contract.invalid && contract.touched }">
                  <label class="col-form-label col-form-label-sm">Tipo de Contrato</label>
                  <ng-select
                    [items]="tc"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="contract">
                  </ng-select>
                  <div *ngIf="contract.errors && (contract.dirty || contract.touched)">
                    <span *ngIf="contract.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="contract.value === '4'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichContract.invalid && whichContract.touched }">
                  <label class="col-form-label col-form-label-sm">Cual?</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="contract.value !== '4'" formControlName="whichContract">
                  <div *ngIf="whichContract.errors && (whichContract.dirty || whichContract.touched)">
                    <span *ngIf="whichContract.errors.required">Indique cual</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chevyPlan.invalid && chevyPlan.touched }">
                  <label class="col-form-label col-form-label-sm">Tiene relación con ChevyPlan, GM, Concesionario?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chevyPlan">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chevyPlan.errors && (chevyPlan.dirty || chevyPlan.touched)">
                    <span *ngIf="chevyPlan.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': address2.invalid && address2.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address2">
                  <div *ngIf="address2.errors && (address2.dirty || address2.touched)">
                    <span *ngIf="address2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 3 -->
              <!-- <div class="row"> -->
              <!-- <div class="col-sm-12 col-md-6 col-lg-2">
                <div class="form-group" [ngClass]="{ 'text-danger': country2.invalid && country2.touched }">
                  <label class="col-form-label col-form-label-sm">País</label>
                  <input type="text" class="form-control form-control-sm" readonly formControlName="country2">
                  <div *ngIf="country2.errors && (country2.dirty || country2.touched)">
                    <span *ngIf="country2.errors.required">El país es requerido</span>
                  </div>
                </div>
              </div> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department2.invalid && department2.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c3 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department2">
                  </ng-select>
                  <div *ngIf="department2.errors && (department2.dirty || department2.touched)">
                    <span *ngIf="department2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city2.invalid && city2.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l3 = $event ? $event.localities : null"
                    [items]="c3"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department2.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city2">
                  </ng-select>
                  <div *ngIf="city2.errors && (city2.dirty || city2.touched)">
                    <span *ngIf="city2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location2.invalid && location2.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l3"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city2.value || l3.length === 0"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location2">
                  </ng-select>
                  <div *ngIf="location2.errors && (location2.dirty || location2.touched)">
                    <span *ngIf="location2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone2.invalid && phone2.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <!-- <input #pmc type="text" class="form-control form-control-sm" id="phone-mask-change" placeholder="(###) ### #### o (###) ### ####" [imask]="otherMask" [unmask]="true" (input)="maskPhoneChange($event.target)" formControlName="phone2"> -->
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone2" minlength="8">
                  <div *ngIf="phone2.errors && (phone2.dirty || phone2.touched)">
                    <span *ngIf="phone2.errors.required">Requerido</span>
                    <span *ngIf="phone2.errors?.minlength">
                      El número de Teléfono debe contener 8 digitos
                    </span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 4 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular2.invalid && cellular2.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular2" minlength="10">
                  <div *ngIf="cellular2.errors && (cellular2.dirty || cellular2.touched)">
                    <span *ngIf="cellular2.errors.required">Requerido</span>
                    <span *ngIf="cellular2.errors?.minlength">
                      El número de Celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <div *ngIf="ciiu.value != null && job.value != null && business.value != null && chevyPlan.value != null
                  && contract.value != null && address2.value != null && department2.value != null
                  && city2.value != null && phone2.value != null && cellular2.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="ciiu.value == null || job.value == null || business.value == null || chevyPlan.value == null
                  || contract.value == null || address2.value == null || department2.value == null
                  || city2.value == null || phone2.value == null || cellular2.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloIndependiente" data-toggle="collapse" data-target="#infoIndependiente" aria-expanded="false" aria-controls="infoIndependiente" *ngIf="job.value === '2'">
            <h6 class="mb-0">Solo para independientes</h6>
          </div>
          <div id="infoIndependiente" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloIndependiente" *ngIf="job.value === '2'">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="form-group" [ngClass]="{ 'text-danger': activities2.invalid && activities2.touched }">
                  <label class="col-form-label col-form-label-sm">Especifique su actividad</label>
                  <input type="text" class="form-control form-control-sm" formControlName="activities2">
                  <div *ngIf="activities2.errors && (activities2.dirty || activities2.touched)">
                    <span *ngIf="activities2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': composition.invalid && composition.touched }">
                  <label class="col-form-label col-form-label-sm">Composición</label>
                  <ng-select
                    [items]="c"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="composition">
                  </ng-select>
                  <div *ngIf="composition.errors && (composition.dirty || composition.touched)">
                    <span *ngIf="composition.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': sectorActivity.invalid && sectorActivity.touched }">
                  <label class="col-form-label col-form-label-sm">Sector actividad económica</label>
                  <ng-select
                    [items]="sa"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sectorActivity">
                  </ng-select>
                  <div *ngIf="sectorActivity.errors && (sectorActivity.dirty || sectorActivity.touched)">
                    <span *ngIf="sectorActivity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 2 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chamberOfCommerce.invalid && chamberOfCommerce.touched }">
                  <label class="col-form-label col-form-label-sm">Registrado en la camara de Comercio?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chamberOfCommerce">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chamberOfCommerce.errors && (chamberOfCommerce.dirty || chamberOfCommerce.touched)">
                    <span *ngIf="chamberOfCommerce.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': employees.invalid && employees.touched }">
                  <label class="col-form-label col-form-label-sm"><!-- No. e -->Empleados</label>
                  <ng-select
                    [items]="e"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="employees">
                  </ng-select>
                  <div *ngIf="employees.errors && (employees.dirty || employees.touched)">
                    <span *ngIf="employees.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': participation.invalid && participation.touched }">
                  <label class="col-form-label col-form-label-sm">Participación <sup><strong>1</strong></sup></label>
                  <div class="input-group input-group-sm mb-auto">
                    <input type="text" class="form-control form-control-sm text-right" [imask]="percentMask" [unmask]="'typed'" formControlName="participation">
                    <div class="input-group-prepend">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div *ngIf="participation.errors && (participation.dirty || participation.touched)">
                    <span *ngIf="participation.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub> % de participación en la empresa</sub>
                <div *ngIf="activities2.value != null && composition.value != null && sectorActivity.value != null && chamberOfCommerce.value != null
                  && employees.value != null && participation.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="activities2.value == null || composition.value == null || sectorActivity.value == null || chamberOfCommerce.value == null
                || employees.value == null || participation.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloFinanciera" data-toggle="collapse" data-target="#infoFinanciera" aria-expanded="false" aria-controls="infoFinanciera">
            <h6 class="mb-0">Información financiera</h6>
          </div>
          <div id="infoFinanciera" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloFinanciera">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': monthlyIncome.invalid && monthlyIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Ingresos mensuales <sup><strong>1</strong></sup></label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'"
                      (change)="sumTotalIncome()" placeholder="0" formControlName="monthlyIncome">
                    </span>
                  </div>
                  <div *ngIf="monthlyIncome.errors && (monthlyIncome.dirty || monthlyIncome.touched)">
                    <span *ngIf="monthlyIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': otherIncome.invalid && otherIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Otros ingresos mensuales </label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'" (change)="sumTotalIncome()" placeholder="0" formControlName="otherIncome">
                    </span>
                    </div>
                  <div *ngIf="otherIncome.errors && (otherIncome.dirty || otherIncome.touched)">
                    <span *ngIf="otherIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': descriptionOtherIncome.invalid && descriptionOtherIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Descripción de otros ingresos</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="!otherIncome.value" formControlName="descriptionOtherIncome">
                  <div *ngIf="descriptionOtherIncome.errors && (descriptionOtherIncome.dirty || descriptionOtherIncome.touched)">
                    <span *ngIf="descriptionOtherIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalIncome.invalid && totalIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Total ingresos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'" readonly placeholder="0" formControlName="totalIncome">
                    </span>
                  </div>
                  <div *ngIf="totalIncome.errors && (totalIncome.dirty || totalIncome.touched)">
                    <span *ngIf="totalIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalExpenses.invalid && totalExpenses.touched }">
                  <label class="col-form-label col-form-label-sm">Total egresos mensuales</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'" placeholder="0" formControlName="totalExpenses">
                    </span>
                  </div>
                  <div *ngIf="totalExpenses.errors && (totalExpenses.dirty || totalExpenses.touched)">
                    <span *ngIf="totalExpenses.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalAssets.invalid && totalAssets.touched }">
                  <label class="col-form-label col-form-label-sm">Total activos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'" placeholder="0" formControlName="totalAssets">
                    </span>
                  </div>
                  <div *ngIf="totalAssets.errors && (totalAssets.dirty || totalAssets.touched)">
                    <span *ngIf="totalAssets.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': assetsDetail.invalid && assetsDetail.touched }">
                  <label class="col-form-label col-form-label-sm">Indique detalles de activos</label>
                  <ng-select
                    [items]="a"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    multiple="true"
                    [closeOnSelect]="false"
                    [hideSelected]="true"
                    [virtualScroll]="true"
                    [readonly]="!totalAssets.value"
                    formControlName="assetsDetail">
                  </ng-select>
                  <div *ngIf="assetsDetail.errors && (assetsDetail.dirty || assetsDetail.touched)">
                    <span *ngIf="assetsDetail.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalPassive.invalid && totalPassive.touched }">
                  <label class="col-form-label col-form-label-sm">Total pasivos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="'typed'" placeholder="0" formControlName="totalPassive">
                    </span>
                    </div>
                  <div *ngIf="totalPassive.errors && (totalPassive.dirty || totalPassive.touched)">
                    <span *ngIf="totalPassive.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub> Ingresos mensuales de la actividad principal</sub>
                <div *ngIf="monthlyIncome.value != null && otherIncome.value != null && descriptionOtherIncome.value != null
                  && totalExpenses.value != null && totalAssets.value != null && assetsDetail.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="monthlyIncome.value == null || otherIncome.value == null || descriptionOtherIncome.value == null
                  || totalExpenses.value == null || totalAssets.value == null || assetsDetail.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
        <!-- </div>
      </div> -->
      <!-- Separador -->
      <div class="row justify-content-center">
        <hr style="width: 90%; margin-bottom: 1.45rem;">
      </div>
      <!-- Boton Guardar -->
      <div class="row justify-content-center text-center">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <!-- definir que va a hacer despues que envie el formulario -->
          <button class="btn btn-primary font-weight-bold m-2" title="Guardar">
            <i class="fa fa-save"></i>
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

